import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { dateFormatter, DateFormatTypes, isSuccessResponse } from '../utils'

import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const { data } = isSuccessResponse({ data: response })
  return {
    data:
      data?.processInstances?.map((item) => ({
        ...(item?.batchSummary ?? {}),
        opsMakerUserName: item?.opsMakerUser?.username,
        makerRequestType: item?.requestType,
        actionDownload: 'Download',
        ...item,
      })) ?? [],
    pagination: {
      size: data?.pageSize,
      totalElements: data?.totalItems ?? 0,
      number: data?.pageNumber + 1,
      totalPages: Math.ceil(data?.totalItems / data?.pageSize),
    },
  }
}

const getPosBatchCheckerApi = (data: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getAllCheckerPOSBatchesApi),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: getReqBody(data),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

const getReqBody = (data: any) => {
  return {
    page: RootStore.pagination?.number - 1,
    size: 10,
    ...data,
    startDate: dateFormatter(RootStore.selectedDateInfo?.fromDate + '', DateFormatTypes.DATE_ONLY_WITHOUT_TIME_REVERSE),
    endDate: dateFormatter(RootStore.selectedDateInfo?.toDate + '', DateFormatTypes.DATE_ONLY_WITHOUT_TIME_REVERSE),
  }
}

export { getPosBatchCheckerApi }
